import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState, memo } from "react";

import {
  fetchAllCollectionsIsPinned,
  fetchAllCollectionsIsNotPinned,
  URLs,
} from "../../utils/apis";
import IsPinnedCollectionWindow from "./IsPinnedCollectionWindow";

import {
  Title,
  Text,
  Flex,
  Box,
  TextInput,
  useMantineTheme,
} from "@mantine/core";

import { useMediaQuery } from "@mantine/hooks";

import { MantineReactTable, useMantineReactTable } from "mantine-react-table";
import {
  collectionPinnedTableData,
  collectionPinnedTableColumns,
  collectionPinnedTableOptions,
} from "../../utils/UserProfile/collectionPinnedTable";
import {
  collectionUnPinnedTableData,
  collectionUnPinnedTableColumns,
  collectionUnPinnedTableOptions,
} from "../../utils/UserProfile/collectionUnPinnedTable";
import { useTableIcons } from "../../utils/collectionFound/iconsUtil";

import SetNameCollectionWindow from "./setNameCollectionWindow";
import DescriptionCollectionWindow from "./DescriptionCollectionWindow";
import CustomButton from "../mantineCustomComponents/CustomButton";
import CustomAnchor from "../mantineCustomComponents/CustomAnchor";
import PortfolioCollectionWindow from "./PortfolioCollectionWindow";
import PortfolioCollectionTypeWindow from "./PortfolioCollectionTypeWindow";
import { useStylesTable } from "../../utils/mantine/useStylesTable";
import { useStylesIcons } from "../../utils/mantine/useStylesIcons";
import IsPublicCollectionWindow from "./IsPublicCollectionWindow";

const CollectionNames = ({
  onUpdateStampQuota,
  onNameCollection,
  nameCollectionSuccess,
  open,
  form,
  djangoContext,
}) => {
  const { classes: tableClasses } = useStylesTable();
  const { classes: classesIcons } = useStylesIcons();

  const tabletMediaQuery = useMediaQuery("(max-width: 64em)");
  const { userShortName } = djangoContext;

  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  // Initial state for input values
  const [inputValues, setInputValues] = useState({
    usercollections: [],
    current_page: 1,
    total_pages: 1,
  });

  const [inputValuesIsNotPinned, setInputValuesIsNotPinned] = useState({
    usercollections: [],
    current_page: 1,
    total_pages: 1,
  });

  //Successfully is Pinned name
  const [nameCollectionIsPinned, setNameCollectionIsPinned] = useState("");

  const [portfolioChange, setPortfolioChange] = useState("");

  // Collection Name id
  const [collectionID, setCollectionID] = useState("");

  // Collection Hash
  const [collectionHash, setCollectionHash] = useState("");

  // Collection Is Pinned
  const [isPinned, setIsPinned] = useState(false);

  // Collection Is Public
  const [isPublic, setIsPublic] = useState(false);

  // Collection Description
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchAllCollectionsIsPinned(setInputValues);
    fetchAllCollectionsIsNotPinned(setInputValuesIsNotPinned);
  }, [
    nameCollectionSuccess,
    nameCollectionIsPinned,
    description,
    portfolioChange,
  ]); // updating the list after adding a new Collection Name

  // Icons used within the tables, provided through a custom utility function
  const faIcons = useMemo(() => useTableIcons(), []);

  const [openedModalPinned, setOpenedModalPinned] = useState(false);

  const [openedModalPublic, setOpenedModalPublic] = useState(false);

  const [openedModalPortfolio, setOpenedModalPortfolio] = useState(false);

  const [portfolio, setPortfolio] = useState("");

  const [openedModalPortfolioCollection, setOpenedModalPortfolioCollection] =
    useState(false);

  const [portfolioCollection, setPortfolioCollection] = useState("");

  const [openedModalDescription, setOpenedModalDescription] = useState(false);

  const [openedModalSetName, setOpenedModalSetName] = useState(false);

  const dataPinned = useMemo(
    () =>
      collectionPinnedTableData(
        inputValues["usercollections"],
        setCollectionID,
        setIsPinned,
        setIsPublic,
        setOpenedModalPinned,
        setOpenedModalPublic,
        setOpenedModalDescription,
        form,
        userShortName,
        setPortfolio,
        setOpenedModalPortfolio,
        setPortfolioCollection,
        setOpenedModalPortfolioCollection,
        classesIcons,
        theme,
        tableClasses,
      ),
    [
      inputValues["usercollections"],
      setCollectionID,
      setIsPinned,
      setOpenedModalPinned,
      setOpenedModalPublic,
      setOpenedModalDescription,
      form,
    ],
  );

  // Column definitions for the main table using a utility function
  const columnsPinned = collectionPinnedTableColumns();

  // Configuration options for the main table using Mantine's table library
  const tablePinned = useMantineReactTable(
    collectionPinnedTableOptions(columnsPinned, dataPinned, faIcons, theme),
  );

  const dataUnPinned = useMemo(
    () =>
      collectionUnPinnedTableData(
        inputValuesIsNotPinned["usercollections"],
        setCollectionID,
        setCollectionHash,
        setIsPinned,
        setIsPublic,
        setOpenedModalPinned,
        setOpenedModalPublic,
        setOpenedModalDescription,
        setOpenedModalSetName,
        form,
        userShortName,
        setPortfolio,
        setOpenedModalPortfolio,
        setPortfolioCollection,
        setOpenedModalPortfolioCollection,
        classesIcons,
        theme,
        tableClasses,
      ),
    [
      inputValuesIsNotPinned["usercollections"],
      setCollectionID,
      setCollectionHash,
      setIsPinned,
      setOpenedModalDescription,
      setOpenedModalPinned,
      form,
    ],
  );

  // Column definitions for the main table using a utility function
  const columnsUnPinned = collectionUnPinnedTableColumns();

  // Configuration options for the main table using Mantine's table library
  const tableUnPinned = useMantineReactTable(
    collectionUnPinnedTableOptions(
      columnsUnPinned,
      dataUnPinned,
      faIcons,
      theme,
    ),
  );
  return (
    <Box
      style={() => ({
        paddingTop: "5rem",
        paddingBottom: "6rem",
      })}
    >
      <Title
        order={2}
        styles={(theme) => ({
          root: {
            fontFamily: theme.headings.fontFamily.secondary,
            paddingBottom: "4rem",
            textAlign: "center",
            fontSize: "3em",
            fontWeight: "normal",
          },
        })}
      >
        Create a Collection
      </Title>

      <form
        onSubmit={form.onSubmit(async (values) => {
          onNameCollection(values.collectionName);
          // Ensure description field is cleared before opening create-collection modal
          form.setFieldValue("collectionDescription", "");
          open();
        })}
      >
        <Flex
          gap={theme.flex.gap.medium}
          mb={theme.margin.xxl}
          align={theme.flex.align.center}
          wrap={tabletMediaQuery ? "wrap" : "nowrap"}
          justify={tabletMediaQuery ? "flex-start" : "center"}
          styles={() => ({
            root: {
              display: tabletMediaQuery ? "block" : "flex",
            },
          })}
        >
          <TextInput
            classNames={{
              input: "collection-names-input",
            }}
            styles={() => ({
              root: {
                display: tabletMediaQuery ? "block" : "flex",
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: tabletMediaQuery ? "flex-start" : "center",
                maxWidth: "100%",
              },
              label: {
                paddingRight: 20,
                fontFamily: theme.headings.fontFamily.bold,
                fontSize: "1.2em",
                width: 236,
                textAlign: tabletMediaQuery ? "left" : "right",
              },
              input: {
                paddingRight: 20,
                border: "1px solid rgba(112, 112, 112, 0.5019607843)",
                fontSize: "1rem",
                lineHeight: "1.25rem",
                maxWidth: "100%",
                width: tabletMediaQuery ? "100%" : "22rem",
              },
            })}
            label="New collection name:"
            inputWrapperOrder={["label", "input"]}
            inputContainer={(children) => (
              <Box>
                {children}
                <Box
                  className="collection-error-text"
                  style={(theme) => ({
                    fontSize: "0.93em",
                    lineHeight: "0.93em",
                    position: "absolute",
                    color: theme.customColors.red,
                    fontFamily: theme.headings.fontFamily.light,
                    width: tabletMediaQuery ? "16rem" : "23rem",
                  })}
                >
                  {form.errors.collectionName}
                </Box>
                <Box
                  className="collection-created-text"
                  style={(theme) => ({
                    fontSize: "0.93em",
                    lineHeight: "0.93em",
                    position: "absolute",
                    color: theme.customColors.green,
                    fontFamily: theme.headings.fontFamily.light,
                    width: tabletMediaQuery ? "16rem" : "23rem",
                  })}
                >
                  {nameCollectionSuccess}
                </Box>
              </Box>
            )}
            placeholder="Enter new collection name"
            key={form.key("collectionName")}
            {...form.getInputProps("collectionName")}
          />
          <CustomButton
            text="Create"
            componentClasses="buttonBlack collection-names-button"
          ></CustomButton>
        </Flex>
      </form>

      <Title
        order={2}
        styles={(theme) => ({
          root: {
            fontFamily: theme.headings.fontFamily.secondary,
            paddingTop: "0.5rem",
            paddingBottom: "2.5rem",
            textAlign: "center",
            fontSize: "3em",
            fontWeight: "normal",
          },
        })}
      >
        Manage Collections
      </Title>

      <IsPinnedCollectionWindow
        collectionID={collectionID}
        isPinned={isPinned}
        setNameCollectionIsPinned={setNameCollectionIsPinned}
        openedModalPinned={openedModalPinned}
        onOpenedModalPinned={setOpenedModalPinned}
      />

      <IsPublicCollectionWindow
        collectionID={collectionID}
        isPublic={isPublic}
        setNameCollectionIsPinned={setNameCollectionIsPinned}
        openedModalPublic={openedModalPublic}
        onOpenedModalPublic={setOpenedModalPublic}
      />

      <PortfolioCollectionWindow
        collectionID={collectionID}
        portfolio={portfolio}
        openedModalPortfolio={openedModalPortfolio}
        onOpenedModalPortfolio={setOpenedModalPortfolio}
        setPortfolioChange={setPortfolioChange}
      />

      <PortfolioCollectionTypeWindow
        collectionID={collectionID}
        portfolioCollection={portfolioCollection}
        openedModalPortfolioCollection={openedModalPortfolioCollection}
        onOpenedModalPortfolioCollection={setOpenedModalPortfolioCollection}
        setPortfolioCollectionChange={setPortfolioChange}
      />

      <DescriptionCollectionWindow
        collectionID={collectionID}
        onDescription={setDescription}
        openedModalDescription={openedModalDescription}
        onOpenedModalDescription={setOpenedModalDescription}
        theme={theme}
        form={form}
      />

      <SetNameCollectionWindow
        onUpdateStampQuota={onUpdateStampQuota}
        collectionHash={collectionHash}
        openedModalSetName={openedModalSetName}
        onOpenedModalSetName={setOpenedModalSetName}
        setNameCollectionIsPinned={setNameCollectionIsPinned}
        theme={theme}
      />

      <Box
        className="block-pinned"
        style={(theme) => ({
          backgroundColor: theme.customColors.white,
          paddingTop: "1.5em",
          paddingBottom: "2em",
          paddingLeft: "1.5em",
          paddingRight: "1em",
        })}
      >
        <Text
          styles={(theme) => ({
            root: {
              fontSize: "1.5em",
              paddingBottom: "1rem",
              paddingLeft: "1.5rem",
              fontFamily: theme.headings.fontFamily.bold,
            },
          })}
        >
          Pinned Collections
        </Text>
        <Text
          styles={() => ({
            root: {
              paddingBottom: "1rem",
              paddingLeft: "1.5rem",
            },
          })}
        >
          Pinned Collections are available to be selected on the Stamp page.
        </Text>

        {inputValues["usercollections"].length > 0 ? (
          <Box className={tableClasses.table}>
            <MantineReactTable
              mb={theme.margin.mdSpacious}
              table={tablePinned}
            />
          </Box>
        ) : (
          <Text
            styles={() => ({
              root: {
                paddingLeft: "1.5rem",
              },
            })}
          >
            No Collections
          </Text>
        )}
      </Box>

      <Box
        className="block-unpinned"
        style={(theme) => ({
          backgroundColor: theme.customColors.white,
          marginTop: "3em",
          paddingTop: "1.5em",
          paddingBottom: "2em",
          paddingLeft: "1.5em",
          paddingRight: "1em",
          marginBottom: "3em",
        })}
      >
        <Text
          styles={(theme) => ({
            root: {
              fontSize: "1.5em",
              paddingBottom: "1rem",
              paddingLeft: "1.5rem",
              fontFamily: theme.headings.fontFamily.bold,
            },
          })}
        >
          All Unpinned Collections
        </Text>
        <Text
          styles={() => ({
            root: {
              paddingBottom: "1rem",
              paddingLeft: "1.5rem",
            },
          })}
        >
          Unpinned Collections are those that you’ve created but are not pinned
          on the Stamp page menu.
        </Text>

        {inputValuesIsNotPinned["usercollections"].length > 0 ? (
          <Box className={tableClasses.table}>
            <MantineReactTable
              mb={theme.margin.mdSpacious}
              table={tableUnPinned}
            />
          </Box>
        ) : (
          <Text
            styles={() => ({
              root: {
                paddingLeft: "1.5rem",
              },
            })}
          >
            No Collections
          </Text>
        )}
      </Box>
      <CustomAnchor
        text="Back to Stamper"
        componentClasses="buttonBlack anchor"
        href={URLs.STAMP_URL}
        IconChevronLeftEnable={true}
      ></CustomAnchor>
    </Box>
  );
};
CollectionNames.propTypes = {
  djangoContext: PropTypes.object.isRequired,
  onUpdateStampQuota: PropTypes.func,
  onShowConfirmationCollectionCreate: PropTypes.func.isRequired,
  showConfirmationCollectionCreate: PropTypes.bool,
  nameCollection: PropTypes.string.isRequired,
  nameCollectionSuccess: PropTypes.string.isRequired,
  nameCollectionError: PropTypes.bool.isRequired,
  onNameCollectionError: PropTypes.func.isRequired,
  onNameCollection: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  open: PropTypes.func.isRequired,
};
export default memo(CollectionNames);
